import { Button, Paragraph, Title } from "@sicredi/react";
import styles from "./styles.module.scss";
import { formatValueMoney } from "#/contextProver/ContextProverServices";

type CardPlanSmallProps = {
  valorBem: number;
  valorParcela: number;
  prazoRestante: number;
  percentualTaxaAdm: number;
  onClickContratar?: () => void;
};

export function CardPlanSmall({
  valorBem,
  valorParcela,
  prazoRestante,
  percentualTaxaAdm,
  onClickContratar,
}: CardPlanSmallProps) {
  return (
    <div className={styles.card_container}>
      <div className={styles.card_view}>
        <Title className={styles.title} as="h4" weight="semi-bold">
          {formatValueMoney(valorBem)}
        </Title>

        <Paragraph className={styles.paragraph} weight="bold">
          {formatValueMoney(valorParcela)}
        </Paragraph>

        <Paragraph className={styles.paragraph} weight="bold">
          {prazoRestante} meses
        </Paragraph>

        <Paragraph className={styles.paragraph} weight="bold">
          {Number.parseFloat(String(Number(percentualTaxaAdm))).toFixed(2)}% ao
          mês
        </Paragraph>
      </div>
      <Button
        appearance="primary"
        className={styles.button}
        size="small"
        onClick={() => (onClickContratar ? onClickContratar() : undefined)}
      >
        Contratar
      </Button>
    </div>
  );
}
